export default [
  {
    path: '',
    name: 'move order receipt list',
    component: () => import('@/views/app/move-order-receipt/list/page-list.vue'),
    meta: { title: 'Daftar Penerimaan Barang' },
  },
  {
    path: ':id',
    name: 'move order receipt detail',
    component: () => import('@/views/app/move-order-receipt/detail/page-detail.vue'),
    meta: { title: 'Detail Penerimaan Barang' },
  },
]

